<div class="container result-container">
  <div class="row justify-content-center">
    <div class="col-12 col-xxl-6 mt-3">
      <div class="cell cell-single">
        <div class="cell-icon">
          <img
            src="https://cf-cdn.speedcheck.org/images/angular-icons/ping-icon.png"
            srcset="
              https://cf-cdn.speedcheck.org/images/angular-icons/ping-icon.png    1x,
              https://cf-cdn.speedcheck.org/images/angular-icons/ping-icon@2x.png 2x,
              https://cf-cdn.speedcheck.org/images/angular-icons/ping-icon@3x.png 3x
            "
            alt="Ping icon"
            height="24"
            width="24"
            />
        </div>
        <div class="cell-label">
          {{ "latency.title" | translate }}
        </div>
        <div class="cell-value">{{ ping }} <span class="unit">ms</span></div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="cell cell-triple">
            <div class="row">
              <div class="col-12">
                <div class="cell-icon">
                  <img
                    src="https://cf-cdn.speedcheck.org/images/angular-icons/download-icon.png"
                    srcset="
                      https://cf-cdn.speedcheck.org/images/angular-icons/download-icon.png    1x,
                      https://cf-cdn.speedcheck.org/images/angular-icons/download-icon@2x.png 2x,
                      https://cf-cdn.speedcheck.org/images/angular-icons/download-icon@3x.png 3x
                    "
                    alt="Ping icon"
                    height="24"
                    width="24"
                    />
                </div>
                <div class="cell-label">
                  {{ "download.title" | translate }}
                </div>
                <div class="cell-value">
                  {{ download }} <span class="unit">Mbps</span>
                  <!-- 487.51<span class="unit"> Mbps</span> -->
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-5">
                <div class="row">
                  <div class="col no-padding">
                    <div class="cell-triple-sublabel">
                      {{ "resultScreen.stability" | translate }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col no-padding">
                    <div class="cell-triple-sublabel">
                      {{ "resultScreen.transferredData" | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col no-padding">
                <div class="cell-triple-histogram">
                  <app-tests-chart
                    [testsStatus]="downloadHistogramToPlot"
                    [smoothCorners]="true"
                    [width]="120"
                    [height]="42"
                    >
                  </app-tests-chart>
                </div>
              </div>
              <div class="col-3">
                <div class="row">
                  <div class="col no-padding">
                    <div class="cell-triple-subvalue">
                      {{ downloadStability }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col no-padding">
                    <div class="cell-triple-subvalue">
                      {{ downloadedData }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ISG -->

            @if (offerConfig) {
              <div>
                <div class="row">
                  <div class="col-12">
                    <div class="cell-icon">
                      <img
                        src="https://cf-cdn.speedcheck.org/images/angular-icons/internet-concierge-icon.png"
                      srcset="
                        https://cf-cdn.speedcheck.org/images/angular-icons/internet-concierge-icon.png    1x,
                        https://cf-cdn.speedcheck.org/images/angular-icons/internet-concierge-icon@2x.png 2x,
                        https://cf-cdn.speedcheck.org/images/angular-icons/internet-concierge-icon@3x.png 3x
                      "
                        alt="Ping icon"
                        height="24"
                        width="24"
                        />
                    </div>
                    <div class="cell-label">Speedcheck Internet Concierge</div>
                    <div class="cell-value" style="color: red">Call Now!</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-9">
                    <div class="row">
                      <div class="col no-padding">
                        <div class="cell-triple-sublabel">
                          Faster Internet Plans Available For You
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="row">
                      <div class="col no-padding">
                        <div class="cell-triple-subvalue">
                          📞&nbsp;&nbsp;
                          <a
                            class="vpn-cta"
                          [eventTracker]="{
                            action: 'click_out',
                            category: 'partner',
                            label: 'isg'
                          }"
                            href="tel:855-908-9120"
                            >855-908-9120</a
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="cell cell-triple">
              <div class="row">
                <div class="col-12">
                  <div class="cell-icon">
                    <img
                      src="https://cf-cdn.speedcheck.org/images/angular-icons/upload-icon.png"
                    srcset="
                      https://cf-cdn.speedcheck.org/images/angular-icons/upload-icon.png    1x,
                      https://cf-cdn.speedcheck.org/images/angular-icons/upload-icon@2x.png 2x,
                      https://cf-cdn.speedcheck.org/images/angular-icons/upload-icon@3x.png 3x
                    "
                      alt="Ping icon"
                      height="24"
                      width="24"
                      />
                  </div>
                  <div class="cell-label">
                    {{ "upload.title" | translate }}
                  </div>
                  <div class="cell-value">
                    {{ upload }} <span class="unit">Mbps</span>
                    <!-- 49.27<span class="unit"> Mbps</span> -->
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-5">
                  <div class="row">
                    <div class="col no-padding">
                      <div class="cell-triple-sublabel">
                        {{ "resultScreen.stability" | translate }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding">
                      <div class="cell-triple-sublabel">
                        {{ "resultScreen.transferredData" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col no-padding">
                  <div class="cell-triple-histogram">
                    <app-tests-chart
                      [testsStatus]="uploadHistogramToPlot"
                      [smoothCorners]="true"
                      [width]="120"
                      [height]="42"
                      >
                    </app-tests-chart>
                  </div>
                </div>
                <div class="col-3">
                  <div class="row">
                    <div class="col no-padding">
                      <div class="cell-triple-subvalue">
                        {{ uploadStability }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding">
                      <div class="cell-triple-subvalue">
                        {{ uploadedData }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="cell cell-double">
              <div class="row">
                <div class="col-12">
                  <div class="cell-icon">
                    <img
                      src="https://cf-cdn.speedcheck.org/images/angular-icons/ip-icon.png"
                    srcset="
                      https://cf-cdn.speedcheck.org/images/angular-icons/ip-icon.png    1x,
                      https://cf-cdn.speedcheck.org/images/angular-icons/ip-icon@2x.png 2x,
                      https://cf-cdn.speedcheck.org/images/angular-icons/ip-icon@3x.png 3x
                    "
                      alt="Ping icon"
                      height="24"
                      width="24"
                      />
                  </div>
                  <div class="cell-label">IP-Address</div>
                  <div class="cell-value">
                    <!-- 233.231.51.218 -->
                    {{ ipv4 }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="cell-triple-sublabel ipv6-title">IPv6</div>
                  <div class="cell-triple-subvalue ipv6">
                    <!-- 2A02:8106:233:6700:8DA2:B4B3:DB8D:2E40 -->
                    {{ ipv6 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="cell cell-single">
              <div class="cell-icon">
                <img
                  src="https://cf-cdn.speedcheck.org/images/angular-icons/provider-icon.png"
                srcset="
                  https://cf-cdn.speedcheck.org/images/angular-icons/provider-icon.png    1x,
                  https://cf-cdn.speedcheck.org/images/angular-icons/provider-icon@2x.png 2x,
                  https://cf-cdn.speedcheck.org/images/angular-icons/provider-icon@3x.png 3x
                "
                  alt="Ping icon"
                  height="24"
                  width="24"
                  />
              </div>
              <div class="cell-label">
                {{ "provider.title" | translate }}
              </div>
              <div class="cell-value">
                {{ isp }}
                <!-- Vodafone GmbH -->
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="cell cell-double">
              <div class="row">
                <div class="col-12">
                  <div class="cell-icon">
                    <img
                      src="https://cf-cdn.speedcheck.org/images/angular-icons/security-icon.png"
                    srcset="
                      https://cf-cdn.speedcheck.org/images/angular-icons/security-icon.png    1x,
                      https://cf-cdn.speedcheck.org/images/angular-icons/security-icon@2x.png 2x,
                      https://cf-cdn.speedcheck.org/images/angular-icons/security-icon@3x.png 3x
                    "
                      alt="Security icon"
                      height="24"
                      width="24"
                      />
                  </div>
                  <div class="cell-label">
                    {{ "resultScreen.vpn.security" | translate }}
                  </div>
                  <div class="cell-value" style="color: red">
                    {{ "resultScreen.vpn.stateUnprotected" | translate }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="cell-triple-sublabel ipv6-title">
                    {{ "resultScreen.vpn.pitch" | translate }}
                  </div>
                  <div class="cell-triple-subvalue ipv6">
                    🔐&nbsp;&nbsp;<a
                    class="vpn-cta"
                    [eventTracker]="{
                      action: 'click_out',
                      category: 'partner',
                      label: 'nordvpn'
                    }"
                    href="https://go.nordvpn.net/aff_c?offer_id=55&aff_id=24529&url_id=315&source=w-sc-1-cta"
                    >{{ "resultScreen.vpn.cta" | translate }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Suggestion Side -->
    </div>

    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-xl-6">
        <div class="button-container text-center">
          <retry-button (notify)="onRestart($event)"></retry-button>
        </div>
      </div>
    </div>

    <!-- Popup -->

    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-7">
        @if (isMobile) {
          <div>
            @if (isAndroid) {
              <div>
                <a (click)="storeClick()" class="text-primary">
                  <div class="store-container">
                    <div class="app-image-container">
                      <img
                        class="app-image"
                        src="https://cf-cdn.speedcheck.org/assets/images/store-image.jpg"
                        width="100"
                        height="116"
                        style="max-width: none"
                        />
                    </div>
                    <div>
                      <p style="width: 98%; margin-bottom: 0px">
                        <b>Download</b> the <b>free Speedcheck app</b> to run the most
                        powerful speed test on your mobile device.
                      </p>
                      <div>
                        <img
                          class="store-button"
                          src="https://cf-cdn.speedcheck.org/assets/images/google-play-button-44.png"
                    srcset="
                      https://cf-cdn.speedcheck.org/assets/images/google-play-button-44.png    1x,
                      https://cf-cdn.speedcheck.org/assets/images/google-play-button-44@2x.png 2x,
                      https://cf-cdn.speedcheck.org/assets/images/google-play-button-44@3x.png 3x
                    "
                          height="44"
                          width="151"
                          />
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            } @else {
              <a (click)="storeClick()" class="text-primary">
                <div class="store-container">
                  <div class="app-image-container">
                    <img
                      class="app-image"
                      src="https://cf-cdn.speedcheck.org/assets/images/store-image.jpg"
                      width="100"
                      height="116"
                      style="max-width: none"
                      />
                  </div>
                  <div>
                    <p style="width: 98%; margin-bottom: 0px">
                      <b>Download</b> the <b>free Speedcheck app</b> to run the most
                      powerful speed test on your mobile device.
                    </p>
                    <div>
                      <img
                        class="store-button"
                        src="https://cf-cdn.speedcheck.org/assets/images/app-store-button-44.png"
                    srcset="
                      https://cf-cdn.speedcheck.org/assets/images/app-store-button-44.png    1x,
                      https://cf-cdn.speedcheck.org/assets/images/app-store-button-44@2x.png 2x,
                      https://cf-cdn.speedcheck.org/assets/images/app-store-button-44@3x.png 3x
                    "
                        height="44"
                        width="132"
                        />
                    </div>
                  </div>
                </div>
              </a>
            }
          </div>
        }
      </div>
    </div>
  </div>
